import React, { FC } from 'react';
import { SystemIconButton, SystemIconProps } from '../Icon';
import { Uds } from '../../types';
import { TagOption } from './utils/Tags.types';

export type TagOptionActionProps = Uds<{
  onClick: (option?: TagOption) => void;
  option?: TagOption;
  iconName: SystemIconProps['name'];
  key: string;
}>;

export const TagOptionAction: FC<React.PropsWithChildren<TagOptionActionProps>> = ({
  onClick,
  option,
  iconName,
  key,
  dataTest
}) => (
  <SystemIconButton
    key={key}
    dataTest={dataTest}
    style={{ pointerEvents: 'all' }}
    iconName={iconName}
    onClick={(e) => {
      e.stopPropagation();
      onClick?.(option);
    }}
    size="small"
  />
);

export const EditTagOptionAction: FC<React.PropsWithChildren<Omit<TagOptionActionProps, 'iconName'>>> = ({
  onClick,
  option,
  key,
  dataTest
}) => <TagOptionAction iconName="edit" onClick={onClick} option={option} key={key} dataTest={dataTest} />;

export const DeleteTagOptionAction: FC<React.PropsWithChildren<Omit<TagOptionActionProps, 'iconName'>>> = ({
  onClick,
  option,
  key,
  dataTest
}) => <TagOptionAction iconName="delete" onClick={onClick} option={option} key={key} dataTest={dataTest} />;
